import { Component, Input } from '@angular/core';
import { Location } from '../../../../shared/models/v2/search';
import { clean } from '../../utils/clean';
import { DirectionsService } from 'src/app/shared/services/directions/directions.service';
import { CjaTagService } from 'src/app/shared/services/cja-tag/cja-tag.service';

@Component({
  selector: 'fal-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {
  private _location: Location | undefined;
  @Input()
  public get location(): Location | undefined {
    return this._location;
  }
  public set location(value: Location | undefined) {
    if (!value) {
      return;
    }

    this._location = value;
    this.setContactInfo(value);
  }

  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zip?: string;
  phoneNumbers: string[] = [];
  tollFreeNumbers?: string[] = [];
  faxNumbers?: string[] = [];
  email?: string;
  website?: string;

  get isVisible(): boolean {
    return !!this.phoneNumbers?.length || !!this.tollFreeNumbers?.length || !!this.faxNumbers?.length || !!this.email || !!this.website;
  }

  get isAddressVisible(): boolean {
    return !!this.addressLine1 || !!this.city || !!this.state || !!this.zip;
  }

  constructor(private directionsService: DirectionsService, private cjaTagService: CjaTagService) {
    // intentionally empty
  }

  setContactInfo(location: Location): void {
    this.phoneNumbers = location.phoneNumber && location.phoneNumber.length > 0 ? clean(location.phoneNumber) : [];
    this.tollFreeNumbers = location.tollFreeNumber && location.tollFreeNumber.length > 0 ? clean(location.tollFreeNumber) : [];
    this.faxNumbers = location.faxNumber && location.faxNumber.length > 0 ? clean(location.faxNumber) : [];
    this.email = location.email;
    this.website = location.website;
    this.addressLine1 = location.address.addressLine1;
    this.addressLine2 = location.address.addressLine2;
    this.city = location.address.city;
    this.state = location.address.state;
    this.zip = location.address.zipCode;
  }

  getDirections(): void {
    if (!this.addressLine1 || !this.city || !this.state || !this.zip) return;
    const url = this.directionsService.getDirectionsUrl(this.addressLine1, this.city, this.state, this.zip);
    window.open(url, '_blank')?.focus();
    this.cjaTagService.logCJAEvent({
      event: 'customEvent',
      event_name: 'find_location:get directions',
      event_category: 'find a location',
      event_action: 'get directions',
      event_label: 'click',
      'link.URL': url, // URL of the href for the direction link
      patientEngagement: 'true',
      visitor_loginStatus: 'false' // true or false based on if the user is logged in
    });
  }

}
